import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TakeActionComponent } from '@kp/screen-take-action/components/take-action/take-action.component';
import { ScreenTakeActionComponent } from '@kp/screen-take-action/screen-take-action.component';

const routes: Routes = [
  {
    path: '',
    component: ScreenTakeActionComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScreenTakeActionRoutingModule {
  static components = [ScreenTakeActionComponent, TakeActionComponent];
}
